import { IIconProps } from '@fluentui/react';
import { ErrorType } from '../../../models/HttpError';
import { AppState } from '../../../redux/reducers';
import { Person } from '../../../models/Entities/Person/Person';

// store
import * as PersonsStore from '../../../redux/middleware/Persons.Middleware';

//#region Icons
export const AddIcon: IIconProps = { iconName: 'AddFriend' };
export const EditIcon: IIconProps = { iconName: 'Edit' };
export const ViewIcon: IIconProps = { iconName: 'ContactCard' };
export const RefreshIcon: IIconProps = { iconName: 'Refresh' };
//#endregion Icons

export interface IProps {}

interface ConnectedProps {
  isLoading: boolean | undefined;
  isLoadingSuccessfully: boolean | undefined;
  failOnLoading: boolean | undefined;
  isDeleting: boolean | undefined;
  failOnDeleting: boolean | undefined;
  isFixingIdentifiers: boolean | undefined;
  hasBrokenIdentifiers: boolean;
  error: ErrorType | undefined;
  persons: Person[];
}

interface DispatchProps {
  GetAllPersons: typeof PersonsStore.actionCreators.GetAllPersons;
  DeletePerson: typeof PersonsStore.actionCreators.DeletePerson;
  FixPersonIdentifiers: typeof PersonsStore.actionCreators.FixPersonIdentifiers;
}

export type Props = IProps & ConnectedProps & DispatchProps;

const EmptyIdentifier = '00000000-0000-0000-0000-000000000000';

export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
  isLoading: state.Persons?.isLoadingAll,
  isLoadingSuccessfully: state.Persons?.successLoadingAll,
  failOnLoading: state.Persons?.failOnLoadingAll,
  isDeleting: state.Persons?.isDeletingOne,
  failOnDeleting: state.Persons?.failOnDeletingOne,
  isFixingIdentifiers: state.Persons?.isFixingIdentifiers,
  hasBrokenIdentifiers:
    state.Persons?.list?.some((person: Person) => person.personIdentifier === EmptyIdentifier) || false,
  error: state.Persons?.error,
  persons: (state.Persons?.list ?? [])
    .filter((person: Person) => !person.isDeleted)
    .slice()
    .sort((a: Person, b: Person) => (a.businessName || '').localeCompare(b.businessName || '')),
  ...ownProps
});

export const mapDispatchToProps = {
  ...PersonsStore.actionCreators
};
